export enum ParamsKeyEnum {
  HIDE_HOME_ELEMENTS = 'HIDE_HOME_ELEMENTS',
  HIDE_INACTIVE_MENUS = 'HIDE_INACTIVE_MENUS',
}
